import { TMaxResolutionLimits } from '@abrController/Estimators/MaxResolutionsEstimator/IMaxResolutionLimits';

// eslint-disable-next-line @typescript-eslint/typedef
export const AbrControllerEvents = {
  resolutionsConstraintsAvailable: 'AbrController.resolutionsConstraintsAvailable',
} as const;

export type TAbrControllerEvents = {
  [AbrControllerEvents.resolutionsConstraintsAvailable]: TMaxResolutionLimits;
};
